import React from "react"

export const getCareTypeContextData = (careType) => ({
  careType: careType || null,
  agnostic: careType === null,
})

const CareTypeContext = React.createContext(null)
export default CareTypeContext
